import { Card, Icon, SearchSVG } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";
import { ContentProps } from "@/components/ContentPromotions/types/ContentProps.interface";
import {
  cardContentCss,
  cardCss,
  cardImageCss,
  searchIconCss,
  variant1Css,
  variant2Css,
  variant3Css,
  variant4Css,
  variant5Css,
} from "./ContentTypeCard.style";

import ExcitedImage from "./images/Excited.svg?component";
import MagnifyingImage from "./images/Magnifying.svg?component";
import SpeakerImage from "./images/Speaker.svg?component";
import ThumbsUpImage from "./images/Thumbs-up.svg?component";
import WorkingImage from "./images/Working.svg?component";

type CardProps = React.ComponentPropsWithRef<typeof Card>;
const CardWithTrackEvent = withTrackEvent<CardProps>(Card);

interface ContentTypeCardProps {
  cardIndex?: number;
}

type Props = ContentTypeCardProps & ContentProps;

const ContentTypeCard = (props: Props) => {
  const { title, href, cardIndex = 0 } = props;

  const variants = [
    {
      svg: <ExcitedImage />,
      css: variant1Css,
    },
    {
      svg: <MagnifyingImage />,
      css: variant2Css,
    },
    {
      svg: <SpeakerImage />,
      css: variant3Css,
    },
    {
      svg: <ThumbsUpImage />,
      css: variant4Css,
    },
    {
      svg: <WorkingImage />,
      css: variant5Css,
    },
  ];

  const variantIndex = cardIndex % variants.length;
  const variant = variants[variantIndex];

  return (
    <CardWithTrackEvent
      __css={[cardCss, variant?.css]}
      href={href}
      objectType={objectTypes.content}
      actionPrefix={actionPrefixes.initiate}
      actionName={actionNames.navigate}
      streamProperties={{
        description: "Navigate to search from Content Promotion preview",
      }}
      dataProps={{
        "data-qa-selector": "content-promotion-content-type-card",
      }}
    >
      <div css={cardContentCss}>
        <Icon
          SvgComponent={SearchSVG}
          size={Icon.sizes.md}
          __cssFor={{ root: searchIconCss }}
        />
        {title}
      </div>
      <div css={cardImageCss}>{variant?.svg}</div>
    </CardWithTrackEvent>
  );
};

export default ContentTypeCard;
